/**
 * Command Center — contract path builders (CC-0).
 */

import { buildContractPath } from "../../api/contract-client.js";

export const CC_POLL_MS = 8000;
export const CC_EVENTS_LIMIT = 24;
export const CC_SNAPSHOTS_LIMIT = 4;

export function buildCcOverviewPath() {
  return buildContractPath("get__dashboard_overview");
}

export function buildCcDevicesPath(query) {
  return buildContractPath("get__devices", query ? { query } : undefined);
}

export function buildCcMapSnapshotPath() {
  return buildContractPath("get__devices_map-snapshot");
}

export function buildCcGroupsHubPath() {
  return buildContractPath("get__admin_groups-hub_summary");
}

export function buildCcEventsPath(query) {
  return buildContractPath("get__events", { query });
}

export function buildCcEventDetailPath(eventId) {
  return buildContractPath("get__events_p", { pathParams: [String(eventId)] });
}

export function buildCcAiIncidentPath(eventId) {
  return buildContractPath("get__ai_incidents_p", { pathParams: [String(eventId)] });
}

export function buildCcSnapshotsPath(query) {
  return buildContractPath("get__admin_camera-snapshots", query ? { query } : undefined);
}

export function buildCcSnapshotImagePath(snapshotId) {
  return buildContractPath("get__admin_camera-snapshots_p_image", {
    pathParams: [String(snapshotId)],
  });
}

export function buildCcActivitySignalsPath(query) {
  return buildContractPath("get__activity_signals", query ? { query } : undefined);
}

export function buildCcAlarmsSummaryPath() {
  return buildContractPath("get__alarms_summary");
}

export function buildCcAlertRecipientsPath() {
  return buildContractPath("get__admin_alert-recipients");
}

export function buildCcDeviceAlarmFeedPath(deviceId, sinceHours = 24) {
  return buildContractPath("get__devices_p_alarm-feed", {
    pathParams: [String(deviceId)],
    query: { since_hours: String(sinceHours) },
  });
}

export function buildCcPostAlertsPath() {
  return buildContractPath("post__alerts");
}

export function buildCcLocationsLatestPath(query) {
  return buildContractPath("get__locations_latest", query ? { query } : undefined);
}
